import type { Row } from "react-table";
import { fuzzyTextFilter, fuzzyGlobalTextFilter, numericTextFilter } from ".";

export const defaultFilterTypes = {
    fuzzyText: fuzzyTextFilter,
    fuzzyGlobalText: fuzzyGlobalTextFilter,
    numeric: numericTextFilter,
    text: (rows: Row<any>[], id: string, filterValue: string) => {
        return rows.filter((row) => {
            const rowValue = row.values[id];
            return rowValue !== undefined
                ? String(rowValue).toLowerCase().startsWith(String(filterValue).toLowerCase())
                : true;
        });
    },
};
